import * as types from './mutation-types'

export default {
  [types.SHOW_SIDEBAR] (state, payload) {
    state.showSidebar = payload === undefined ? !state.showSidebar : payload
  }
}
